import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'loadMoreItems' })
export class LoadMoreItemsPipe implements PipeTransform {

  transform(value: any, numOfItems: any): any {
    // if (value.length === 0) {
    //   return ['none'];
    // }
    if (value && numOfItems <= value.length) {
      return value.slice(0, numOfItems);
    }
    return value;
  }

}
